import { Tempo } from "./usuario/EstatisticasLeitura";

export class ProgressoLeitura {
  public progresso: number;
  public tempoRestante: Tempo;
}
